import { MessageCircle, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { whatsappUrl } from "../config";

export const Contact = () => (
  <section id="contacto" data-testid="contact-section" className="relative overflow-hidden bg-slate-950 py-24 sm:py-32">
    <div
      className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full opacity-30"
      style={{ background: "radial-gradient(circle, #4F5BD5 0%, transparent 65%)" }}
    />
    <div
      className="pointer-events-none absolute -bottom-48 -left-32 h-[420px] w-[420px] rounded-full opacity-20"
      style={{ background: "radial-gradient(circle, #818CF8 0%, transparent 65%)" }}
    />
    <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-indigo-300">Contacto</p>
        <h2
          className="mt-4 text-3xl font-medium leading-tight tracking-tight text-white sm:text-5xl"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Contanos sobre tu evento
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-300">
          Boda, quinceaños, celebración familiar o evento empresarial: escribinos y te mostramos cómo quedaría tu invitación Plus, sin compromiso.
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            data-testid="closing-whatsapp-button"
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-emerald-500 px-8 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-emerald-600"
          >
            <MessageCircle className="h-5 w-5" />
            Consultar por WhatsApp
          </a>
          <a
            data-testid="closing-demo-link"
            href={whatsappUrl("Hola Pro360, quiero ver una demo de Invitaciones Digitales Plus.")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-white/25 px-8 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-white/10"
          >
            Pedir una demo guiada
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
        <p className="mt-6 text-xs text-slate-400">Respondemos personalmente cada consulta.</p>
      </Reveal>
    </div>
  </section>
);
